module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.tables && _vm.tables.length > 0),
            expression: "tables && tables.length > 0"
          }],
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": "",
            "loading": _vm.req.loading
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showdetail = true
            }
          },
          slot: "activator"
        }, on), [_c('v-icon', {
          attrs: {
            "color": "amber"
          }
        }, [_vm._v("flash_on")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showdetail),
      callback: function($$v) {
        _vm.showdetail = $$v
      },
      expression: "showdetail"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "overline py-1 grey darken-3 white--text"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "amber"
    }
  }, [_vm._v("flash_on")]), _vm._v("\n      The following codes will automatically be added to this appointment\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showdetail = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.tables), function(table, index) {
    return _c('v-card', {
      key: (index + "-" + (table.id)),
      staticClass: "ma-2"
    }, [_c('v-card-title', {
      staticClass: "overline grey lighten-4",
      domProps: {
        "textContent": _vm._s(table.title)
      }
    }), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "dense": "",
        "hide-actions": "",
        "hide-default-footer": "",
        "disable-initial-sort": "",
        "disable-sort": "",
        "disable-filter": "",
        "disable-pagination": "",
        "no-data-text": "No autocodes found",
        "headers": table.headers,
        "items": table.codes,
        "items-per-page": 10
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(props.item.icd10 || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.process || '-'))]), _vm._v(" "), _c('td', [(props.item.price) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.formatCurrency(props.item.currency, props.item.price)) + "\n            ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), (table.id === 'client') ? [_c('td', [_vm._v(_vm._s(_vm.dateformat(props.item.start_date)))]), _vm._v(" "), _c('td', [(props.item.stop_date) ? _c('span', {
            domProps: {
              "textContent": _vm._s(props.item.stop_date)
            }
          }) : _c('span', [_vm._v("No end date")])])] : _vm._e()]
        }
      }], null, true)
    }), _vm._v(" "), (table.footertext) ? _c('v-footer', {
      staticClass: "caption py-0 pl-2 hidden-xs-only",
      domProps: {
        "textContent": _vm._s(table.footertext)
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-divider')], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-413a78d9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/AutomationIndicator.vue
// module id = 1401
// module chunks = 9